/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrototypesIndexRouteImport } from './routes/prototypes/index'
import { Route as PrototypesClashMeetingRouteImport } from './routes/prototypes/clash-meeting'
import { Route as PrototypesPricingRouteImport } from './routes/prototypes/pricing'
import { Route as PrototypesQuoteRouteImport } from './routes/prototypes/quote'
import { Route as TracesIndexRouteImport } from './routes/traces/index'
import { Route as PProjectIdIndexRouteImport } from './routes/p.$projectId/index'
import { Route as TracesTraceIdIndexRouteImport } from './routes/traces/$traceId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesIndexRoute = PrototypesIndexRouteImport.update({
  id: '/prototypes/',
  path: '/prototypes/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesClashMeetingRoute = PrototypesClashMeetingRouteImport.update({
  id: '/prototypes/clash-meeting',
  path: '/prototypes/clash-meeting',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesPricingRoute = PrototypesPricingRouteImport.update({
  id: '/prototypes/pricing',
  path: '/prototypes/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesQuoteRoute = PrototypesQuoteRouteImport.update({
  id: '/prototypes/quote',
  path: '/prototypes/quote',
  getParentRoute: () => rootRouteImport,
} as any)
const TracesIndexRoute = TracesIndexRouteImport.update({
  id: '/traces/',
  path: '/traces/',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectIdIndexRoute = PProjectIdIndexRouteImport.update({
  id: '/p/$projectId/',
  path: '/p/$projectId/',
  getParentRoute: () => rootRouteImport,
} as any)
const TracesTraceIdIndexRoute = TracesTraceIdIndexRouteImport.update({
  id: '/traces/$traceId/',
  path: '/traces/$traceId/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/prototypes/clash-meeting': typeof PrototypesClashMeetingRoute
  '/prototypes/pricing': typeof PrototypesPricingRoute
  '/prototypes/quote': typeof PrototypesQuoteRoute
  '/prototypes/': typeof PrototypesIndexRoute
  '/traces/': typeof TracesIndexRoute
  '/p/$projectId/': typeof PProjectIdIndexRoute
  '/traces/$traceId/': typeof TracesTraceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/prototypes/clash-meeting': typeof PrototypesClashMeetingRoute
  '/prototypes/pricing': typeof PrototypesPricingRoute
  '/prototypes/quote': typeof PrototypesQuoteRoute
  '/prototypes': typeof PrototypesIndexRoute
  '/traces': typeof TracesIndexRoute
  '/p/$projectId': typeof PProjectIdIndexRoute
  '/traces/$traceId': typeof TracesTraceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/prototypes/clash-meeting': typeof PrototypesClashMeetingRoute
  '/prototypes/pricing': typeof PrototypesPricingRoute
  '/prototypes/quote': typeof PrototypesQuoteRoute
  '/prototypes/': typeof PrototypesIndexRoute
  '/traces/': typeof TracesIndexRoute
  '/p/$projectId/': typeof PProjectIdIndexRoute
  '/traces/$traceId/': typeof TracesTraceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/prototypes/clash-meeting'
    | '/prototypes/pricing'
    | '/prototypes/quote'
    | '/prototypes/'
    | '/traces/'
    | '/p/$projectId/'
    | '/traces/$traceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/prototypes/clash-meeting'
    | '/prototypes/pricing'
    | '/prototypes/quote'
    | '/prototypes'
    | '/traces'
    | '/p/$projectId'
    | '/traces/$traceId'
  id:
    | '__root__'
    | '/'
    | '/prototypes/clash-meeting'
    | '/prototypes/pricing'
    | '/prototypes/quote'
    | '/prototypes/'
    | '/traces/'
    | '/p/$projectId/'
    | '/traces/$traceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrototypesClashMeetingRoute: typeof PrototypesClashMeetingRoute
  PrototypesPricingRoute: typeof PrototypesPricingRoute
  PrototypesQuoteRoute: typeof PrototypesQuoteRoute
  PrototypesIndexRoute: typeof PrototypesIndexRoute
  TracesIndexRoute: typeof TracesIndexRoute
  PProjectIdIndexRoute: typeof PProjectIdIndexRoute
  TracesTraceIdIndexRoute: typeof TracesTraceIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/': {
      id: '/prototypes/'
      path: '/prototypes'
      fullPath: '/prototypes/'
      preLoaderRoute: typeof PrototypesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/clash-meeting': {
      id: '/prototypes/clash-meeting'
      path: '/prototypes/clash-meeting'
      fullPath: '/prototypes/clash-meeting'
      preLoaderRoute: typeof PrototypesClashMeetingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/pricing': {
      id: '/prototypes/pricing'
      path: '/prototypes/pricing'
      fullPath: '/prototypes/pricing'
      preLoaderRoute: typeof PrototypesPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/quote': {
      id: '/prototypes/quote'
      path: '/prototypes/quote'
      fullPath: '/prototypes/quote'
      preLoaderRoute: typeof PrototypesQuoteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/traces/': {
      id: '/traces/'
      path: '/traces'
      fullPath: '/traces/'
      preLoaderRoute: typeof TracesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$projectId/': {
      id: '/p/$projectId/'
      path: '/p/$projectId'
      fullPath: '/p/$projectId/'
      preLoaderRoute: typeof PProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/traces/$traceId/': {
      id: '/traces/$traceId/'
      path: '/traces/$traceId'
      fullPath: '/traces/$traceId/'
      preLoaderRoute: typeof TracesTraceIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrototypesClashMeetingRoute: PrototypesClashMeetingRoute,
  PrototypesPricingRoute: PrototypesPricingRoute,
  PrototypesQuoteRoute: PrototypesQuoteRoute,
  PrototypesIndexRoute: PrototypesIndexRoute,
  TracesIndexRoute: TracesIndexRoute,
  PProjectIdIndexRoute: PProjectIdIndexRoute,
  TracesTraceIdIndexRoute: TracesTraceIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
